import React from 'react';
import styled from 'styled-components';

const DragOverlayWrapper = styled.div`
  min-width: 300px;
  max-width: 450px;
  border-radius: 10px;
  opacity: 0.8;
  background-color: #fff;
  box-shadow: ${props => props.theme.boxShadowSecondary};
  border: 2px solid #fff;
  padding: 0 9px;
  transition: all 0.2s;

  max-height: 80px;
  overflow-y: hidden;
`;

export interface DragOverlayContainerProps
  extends React.HTMLAttributes<HTMLDivElement> {}

/**
 * Visualizzazione per l'utente della posizione in cui sarà spostato il widget
 */
export function DragOverlayContainer(props: DragOverlayContainerProps) {
  return <DragOverlayWrapper {...props} />;
}
